module.exports = __webpack_public_path__ + "img/dric_persiandaric.53165e2.png";